import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-09fa7358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"gap":"10px","height":"100%"} }
const _hoisted_2 = { class: "bank-carousel-card" }
const _hoisted_3 = { class: "bank-carousel-fdic-decoration" }
const _hoisted_4 = { class: "bank-carousel-fdic-text" }
const _hoisted_5 = { class: "bank-carousel-logo-apy" }
const _hoisted_6 = { style: {"align-self":"stretch"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bank-carousel-logo-spacer" }, null, -1))
const _hoisted_9 = { style: {"text-align":"right"} }
const _hoisted_10 = { class: "apy-container bank-carousel-tooltip" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM7.125 12.0444C7.125 11.5612 7.51675 11.1694 8 11.1694C8.48325 11.1694 8.875 11.5612 8.875 12.0444C8.875 12.5276 8.48325 12.9194 8 12.9194C7.51675 12.9194 7.125 12.5276 7.125 12.0444ZM7.96873 4.86324C8.40972 4.84626 8.74442 4.97778 8.96239 5.17401C9.17609 5.36639 9.32295 5.66083 9.32295 6.0684C9.32295 6.40709 9.247 6.57333 9.13953 6.71392C9.01673 6.87456 8.84807 7.01367 8.56145 7.25006C8.51444 7.28883 8.46416 7.3303 8.41048 7.37483L8.39669 7.38514C8.3781 7.39919 8.35254 7.41884 8.32195 7.44324C8.26126 7.49163 8.17826 7.56068 8.0893 7.64339C7.93557 7.78633 7.67307 8.05118 7.55105 8.36696C7.47462 8.56479 7.4234 8.75745 7.39154 8.89641C7.37535 8.96705 7.36354 9.02656 7.3556 9.06947C7.35163 9.09098 7.3486 9.10848 7.34645 9.1213L7.34389 9.13697L7.34309 9.14205L7.34281 9.14387L7.34265 9.14492C7.34264 9.14499 7.34261 9.14521 7.96054 9.23894L7.34265 9.14492C7.29088 9.4862 7.52553 9.80511 7.86681 9.85688C8.20797 9.90862 8.52649 9.67411 8.57842 9.33302C8.57841 9.33309 8.57843 9.33295 8.57842 9.33302L8.57935 9.32737C8.58039 9.32114 8.58219 9.3107 8.58478 9.29669C8.58998 9.26855 8.59827 9.22663 8.60993 9.17574C8.63379 9.07168 8.66933 8.94098 8.71704 8.81748C8.71772 8.81604 8.73184 8.78593 8.7784 8.72864C8.82266 8.67417 8.8793 8.61569 8.94045 8.55884C9.00059 8.50292 9.05842 8.45473 9.1013 8.42054C9.12248 8.40365 9.13939 8.39067 9.15031 8.38242L9.16182 8.37381L9.16289 8.37301L9.17972 8.36084L9.19583 8.34746C9.24132 8.30969 9.28794 8.27151 9.33517 8.23283C9.61389 8.00458 9.91446 7.75843 10.1326 7.47306C10.425 7.09062 10.5729 6.64985 10.5729 6.0684C10.5729 5.33644 10.2972 4.69375 9.79874 4.24502C9.30457 3.80014 8.63765 3.58656 7.92064 3.61417C6.91536 3.65287 6.2512 4.07926 5.86497 4.6724C5.50455 5.2259 5.43281 5.85256 5.42707 6.24866C5.42207 6.5938 5.69781 6.87765 6.04295 6.88265C6.38809 6.88765 6.67194 6.61191 6.67694 6.26676C6.68118 5.97385 6.73795 5.6225 6.91247 5.35449C7.06117 5.12612 7.33836 4.88751 7.96873 4.86324Z",
    fill: "#0069BA"
  })
], -1))
const _hoisted_12 = { class: "bank-carousel-apy bank-carousel-tooltiptext" }
const _hoisted_13 = { class: "bank-carousel-apy-rate" }
const _hoisted_14 = { class: "bank-carousel-our-rating" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bank-carousel-our-rating-text" }, "Our Rating", -1))
const _hoisted_16 = { class: "bank-carousel-rating-wrapper" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "14",
  viewBox: "0 0 15 14",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.36025 0L5.62261 5.34734L0 5.34749L4.54867 8.65251L2.81135 14L7.36025 10.6953L11.9091 14L10.1718 8.65251L14.7205 5.34749L9.09789 5.34734L7.36025 0Z",
    fill: "#FFC507"
  })
], -1))
const _hoisted_18 = { class: "bank-carousel-our-rating-star-rating" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bank-carousel-our-rating-total-star-rating" }, " / 5", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bank-carousel-card-line" }, null, -1))
const _hoisted_21 = { class: "bank-carousel-bankname-productname-text" }
const _hoisted_22 = { class: "bank-carousel-bankname" }
const _hoisted_23 = { class: "bank-carousel-bankname-text" }
const _hoisted_24 = { class: "bank-carousel-product" }
const _hoisted_25 = { class: "bank-carousel-product-text" }
const _hoisted_26 = { class: "bank-carousel-see-offer" }
const _hoisted_27 = ["href", "data-adselector"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bank-carousel-see-offer-button-text" }, "See Offer", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.5 5.25C5.36193 5.25 5.25 5.36193 5.25 5.5V19.5C5.25 19.6381 5.36193 19.75 5.5 19.75H19.5C19.6381 19.75 19.75 19.6381 19.75 19.5V14.269C19.75 13.8547 20.0858 13.519 20.5 13.519C20.9142 13.519 21.25 13.8547 21.25 14.269V19.5C21.25 20.4665 20.4665 21.25 19.5 21.25H5.5C4.5335 21.25 3.75 20.4665 3.75 19.5V5.5C3.75 4.5335 4.5335 3.75 5.5 3.75H10.7111C11.1253 3.75 11.4611 4.08579 11.4611 4.5C11.4611 4.91421 11.1253 5.25 10.7111 5.25H5.5Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.611 4.5C13.611 4.08579 13.9468 3.75 14.361 3.75001L20.5765 3.75005C20.9963 3.75005 21.3365 4.09029 21.3365 4.51004L21.3366 10.5525C21.3366 10.9667 21.0008 11.3025 20.5866 11.3025C20.1724 11.3025 19.8366 10.9667 19.8366 10.5525L19.8365 5.8892L8.46696 17.2586C8.17406 17.5515 7.69919 17.5515 7.4063 17.2586C7.11341 16.9657 7.11342 16.4908 7.40632 16.1979L18.3544 5.25003L14.361 5.25001C13.9467 5.25 13.611 4.91421 13.611 4.5Z",
    fill: "white"
  })
], -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "bank-carousel-sponsornote"
}
const _hoisted_32 = { class: "bank-carousel-sponsornote-note" }
const _hoisted_33 = { class: "bank-carousel-sponsornote-note-detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.mobileCardClassName]),
    style: _normalizeStyle({ width: _ctx.cardWidth + 'px', flexShrink: '0' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.model?.bank?.federallyInsured ? 'Member ' + _ctx.model.bank.sourceName : ''), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              style: {"max-width":"85px","max-height":"70px"},
              src: `/content/logos/${_ctx.model?.account?.bankUrl}.gif`,
              alt: "Bank Logo"
            }, null, 8, _hoisted_7)
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(" APY "),
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, " APY = Annual Percentage Yield Rates as of " + _toDisplayString(_ctx.formattedDate), 1)
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.model?.account?.apy?.toFixed(2)) + "% ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.ratingDisplay), 1),
            _hoisted_19
          ])
        ]),
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.model?.account?.bankName), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.model?.account?.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("a", {
            class: "bank-carousel-see-offer-button",
            href: _ctx.model.trackedLink,
            "data-adselector": _ctx.zoneKey === 'da-bp-carouseltop' ? `BankPageTopCarousel[${_ctx.index}]` : `BankPageBottomCarousel[${_ctx.index}]`,
            rel: "nofollow",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logAdClickV2($event, _ctx.model.trackedLink))),
            target: "_blank"
          }, _hoisted_30, 8, _hoisted_27)
        ]),
        (_ctx.model.adCopy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, [
                _createTextVNode("Sponsored Note: "),
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.model.adCopy), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 6))
}